// <!-- GRACE:MODULE_START name="ui_auth" -->
// <!-- GRACE:DEPENDENCY target="ui_auth" -->
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../../services/authService';

interface ForgotPasswordForm {
  email: string;
}

// <!-- GRACE:CONTRACT function="ForgotPasswordPage" -->
export default function ForgotPasswordPage() {
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm<ForgotPasswordForm>();

  const onSubmit = async (data: ForgotPasswordForm) => {
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const res = await requestPasswordReset(data.email);
      setMessage(res.message);
    } catch (e: any) {
      setError(e.message || 'Ошибка отправки письма');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-2xl border bg-white p-8 shadow-sm">
        <div className="mb-6">
          <Link to="/login" className="mb-4 inline-block text-sm text-gray-500 hover:text-gray-900">
            &larr; Ко входу
          </Link>
          <h1 className="text-xl font-semibold">Восстановление пароля</h1>
          <p className="mt-1 text-sm text-gray-500">
            Укажите email, с которым вы регистрировались. Мы отправим ссылку для смены пароля.
          </p>
        </div>

        {message && (
          <div className="mb-4 rounded-lg bg-green-50 p-3 text-sm text-green-700">{message}</div>
        )}
        {error && (
          <div className="mb-4 rounded-lg bg-red-50 p-3 text-sm text-red-600">{error}</div>
        )}

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium">Email</label>
            <input
              type="email"
              className="w-full rounded-lg border px-3 py-2 text-sm focus:border-gray-400 focus:outline-none"
              placeholder="email@example.com"
              {...register('email', { required: 'Введите email' })}
            />
            {errors.email && <p className="mt-1 text-xs text-red-500">{errors.email.message}</p>}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg bg-gray-900 py-2.5 text-sm font-medium text-white hover:bg-gray-800 disabled:opacity-50"
          >
            {loading ? 'Отправка...' : 'Отправить ссылку'}
          </button>
        </form>
      </div>
    </div>
  );
}
// <!-- GRACE:MODULE_END name="ui_auth" -->
